<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { isObject } from "@/common/lib/guards";

const props = defineProps<{
  href?: RouteLocationRaw | string;
}>();

const linkProps = computed(() => {
  const isRoute = isObject(props.href);
  if (isRoute) {
    return {
      to: props.href,
    };
  }

  return {
    href: props.href,
  };
});
</script>

<template>
  <component
    :is="isObject(props.href) ? RouterLink : 'a'"
    v-bind="linkProps"
    class="rounded-sm text-blue-600 outline-hidden outline-offset-2 hover:underline focus-visible:outline-1 focus-visible:outline-indigo-600"
  >
    <slot />
  </component>
</template>
